import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import s from './SubmitButton.module.scss'

export default function SubmitButton({ disabled, className, children }) {
  return (
    <button className={classNames(s.button, className)} disabled={disabled} type="submit">
      {children}
    </button>
  )
}
SubmitButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  disabled: PropTypes.bool.isRequired
}
